import Vue from "vue";
import Vuex from "vuex";
import products from "./articles.json";
// import products from "./products";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    products,
    snackbar: {
      show: false,
      variant: "success",
      message: "Artikel in den Warenkorb gelegt."
    },
    shippingCost: 5.5,
    cart: [], // { itemId, quantity }
    firstName: "",
    lastName: "",
    street: "",
    plz: "",
    city: "",
    email: "",
    datenverarbeitung: false,
    comment: "",
    zahlungsart: "Vorkasse"
  },

  getters: {
    getProductByName: state => name => {
      return state.products.find(product => product.name === name);
    }
  },

  mutations: {
    addItemToCart(state, payload) {
      const { itemId, quantity } = payload;
      const idx = state.cart.findIndex(product => {
        return product.itemId === itemId;
      });
      if (idx === -1) {
        state.cart.push({ itemId, quantity });
      } else {
        state.cart[idx].quantity += quantity;
      }
    },
    removeItemFromCart(state, payload) {
      const { itemId, quantity } = payload;
      const idx = state.cart.findIndex(product => {
        return product.itemId === itemId;
      });
      if (state.cart[idx].quantity == 1) {
        state.cart.splice(idx, 1);
      } else {
        state.cart[idx].quantity -= quantity;
      }
    },
    updateSnackbar(state, settings) {
      state.snackbar = {
        ...state.snackbar,
        ...settings
      };
    },
    removeArticleFromCart(state, itemId) {
      const idx = state.cart.findIndex(product => {
        return product.itemId.name === itemId;
      });
      state.cart.splice(idx, 1);
      state.cartItems--;
      // console.log("Elemente im Warenkorb: " + state.cart.length)
    },
    updateZahlungsart(state, value) {
      state.zahlungsart = value;
    }
  }
});
